import { requestJson, requestVoid } from '../http'

import type { UpdateApplicationPayload } from '../application/application.types'
import type { DistributorCommitmentDetails, CreateCommitmentApplicationResponse } from './commitment.types'

export const fetchCommitmentApplicationById = async (id: string): Promise<DistributorCommitmentDetails> => {
  return await requestJson<DistributorCommitmentDetails>(`/borgo/distributor/applications/commitment/${id}`, 'GET')
}

//prettier-ignore
export const createCommitmentApplication = async (payload: { type: string, brokerExternalId: string}): Promise<CreateCommitmentApplicationResponse> => {
  return await requestJson<CreateCommitmentApplicationResponse>('/borgo/distributor/applications/commitment/create', 'POST', payload)
}

export const updateCommitmentApplication = async (id: string, payload: UpdateApplicationPayload): Promise<void> => {
  await requestVoid(`/borgo/distributor/applications/commitment/${id}`, 'POST', payload)
}

export const submitCommitmentApplication = async (id: string): Promise<{ message: string }> => {
  return await requestJson<{ message: string }>(`/borgo/distributor/applications/commitment/${id}/submit`, 'POST')
}

export const deleteCommitmentDraft = async (id: string): Promise<void> => {
  await requestVoid(`/borgo/distributor/applications/commitment/${id}`, 'DELETE')
}
